import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text, useTooltip } from '@frontend/design-system';

export const DisabledCalendarFilterSection = ({ label, tooltip }: { label: string; tooltip: string }) => {
  const { triggerProps, tooltipProps, Tooltip } = useTooltip({ placement: 'bottom' });

  return (
    <div
      css={{
        border: `2px solid ${theme.colors.neutral10}`,
        borderRadius: theme.borderRadius.medium,
        marginBottom: theme.spacing(2),
        boxShadow: theme.shadows.light,
      }}
      aria-label={tooltip}
      aria-disabled
    >
      <Tooltip {...tooltipProps}>
        <Text css={{ margin: 0 }} color='white'>
          {tooltip}
        </Text>
      </Tooltip>
      <div
        {...triggerProps}
        css={{
          padding: theme.spacing(2),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Text size='medium' weight='bold' color='disabled'>
          {label}
        </Text>
        <Icon name='caret-down' size={16} color='disabled' />
      </div>
    </div>
  );
};
